import script from "./Chip.vue?vue&type=script&setup=true&lang=js"
export * from "./Chip.vue?vue&type=script&setup=true&lang=js"

import "./Chip.vue?vue&type=style&index=0&id=487f5332&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-487f5332"]])

export default __exports__